import { Navigate, Route, Routes } from 'react-router-dom';
import { useBackgroundSync } from '@/lib/sync';
import { useAvatarWarmup } from '@/lib/warmAvatars';
import { useAuth } from '@/store/auth';
import AuthGate from '@/components/AuthGate';
import { useAudioUnlock } from '@/lib/useAudioUnlock';
import Home from '@/pages/Home';
import NewGame from '@/pages/NewGame';
import PlayGame from '@/pages/PlayGame';
import Rules from '@/pages/Rules';
import History from '@/pages/History';
import JoinLive from '@/pages/JoinLive';
import LivePlay from '@/pages/LivePlay';
import HeartsPlay from '@/pages/HeartsPlay';
import JoinHearts from '@/pages/JoinHearts';
import HeartsRules from '@/pages/HeartsRules';
import NewKlaverjas from '@/pages/NewKlaverjas';
import KlaverjasScore from '@/pages/KlaverjasScore';
import JoinKlaverjasLive from '@/pages/JoinKlaverjasLive';
import KlaverjasPlay from '@/pages/KlaverjasPlay';
import KlaverjasRules from '@/pages/KlaverjasRules';
import Stijlen from '@/pages/Stijlen';
import Uitnodiging from '@/pages/Uitnodiging';
import Beheer from '@/pages/beheer/Index';
import BeheerLogin from '@/pages/beheer/Login';

export default function App() {
  // Best-effort: pushes finished games to the server whenever there is a
  // connection. Never blocks scorekeeping.
  useBackgroundSync();

  // At the root, not on the live screen: the tap that gets you to the table
  // happens on the join screen, so listeners mounted later would miss it.
  useAudioUnlock();

  // Pull the faces into the cache while there is still a connection. Only once
  // this device is actually let in — otherwise every request is a 401.
  useAvatarWarmup(useAuth((state) => state.status) === 'allowed');

  return (
    /* Everything inside is display-only gating; the server enforces on every
       request regardless of what gets rendered here. */
    <AuthGate>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/score/nieuw" element={<NewGame />} />
        <Route path="/score/:gameId" element={<PlayGame />} />
        <Route path="/live" element={<JoinLive />} />
        {/* Shared as a link, so scanning or tapping it lands on the join screen. */}
        <Route path="/join/:code" element={<JoinLive />} />
        <Route path="/live/:code" element={<LivePlay />} />
        <Route path="/klaverjas/nieuw" element={<NewKlaverjas />} />
        <Route path="/klaverjas/live" element={<JoinKlaverjasLive />} />
        {/* Before /klaverjas/:gameId, or a code would be read as a game id. */}
        <Route path="/klaverjas/live/:code" element={<KlaverjasPlay />} />
        <Route path="/klaverjas/:gameId" element={<KlaverjasScore />} />
        <Route path="/harten" element={<JoinHearts />} />
        {/* Shared as a link, so scanning or tapping it lands at the table. */}
        <Route path="/harten/:code" element={<HeartsPlay />} />
        <Route path="/historie" element={<History />} />
        <Route path="/regels" element={<Rules />} />
        <Route path="/regels/hartenjagen" element={<HeartsRules />} />
        <Route path="/regels/klaverjassen" element={<KlaverjasRules />} />
        {/* A scratch page for choosing a look. Delete it, and public/stijlen,
            once a direction is picked. */}
        <Route path="/stijlen" element={<Stijlen />} />
        <Route path="/uitnodiging" element={<Uitnodiging />} />
        <Route path="/beheer" element={<Beheer />} />
        <Route path="/beheer/login" element={<BeheerLogin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthGate>
  );
}
